import { CircularProgress, Stack } from "@mui/material";
import React from "react";
import { ReactElement } from "react";

const Loading = ({show = true}:{show?: boolean}): ReactElement => {
  return (
    <Stack
      sx={{
        color: "grey.500",
        marginTop: "300px",
        display: show ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
      }}
      spacing={2}
      direction="row"
    >
      <CircularProgress color="error" />
    </Stack>
  );
};

export default Loading;